import { render, staticRenderFns } from "./TeacherCardDetailButton.vue?vue&type=template&id=0d6704ab&scoped=true&"
import script from "./TeacherCardDetailButton.vue?vue&type=script&lang=js&"
export * from "./TeacherCardDetailButton.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardDetailButton.vue?vue&type=style&index=0&id=0d6704ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6704ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
